import { registerSymbolIndexParentAsync } from '../build/register-symbol-index-parent.js';
import { scheduleSymbolIndexWarmupInWorkerHost } from '../scheduler/symbol-index-warmup-host.js';
import type { SymbolIndexWorkerInMessage } from './protocol.js';

export async function handleSetupWorkerMessage(msg: SymbolIndexWorkerInMessage): Promise<void> {
  switch (msg.type) {
    case 'registerParent':
      await registerSymbolIndexParentAsync(msg.parentPath);
      return;
    case 'scheduleWarmup':
      scheduleSymbolIndexWarmupInWorkerHost(msg.parentPath);
      return;
    default:
      return;
  }
}
